import { Navigate } from 'react-router-dom';
import { useAuth } from './auth-provider';
import { ReactNode } from 'react';
type ProtectedRouteProps = {
  children: ReactNode;
};

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { user } = useAuth();

  if (!user) {
    return <Navigate to="/login" />;
  }

  if (user.last_sign_in_at === null) {
    return <Navigate to="/accept" />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
